import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import moment from 'moment'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'

import DropDown from './components/DropDown'
import AddVehicleModal from './components/AddVehicleModal'
import EditAdditionalInfo from './components/EditAdditionalInfo'
import AccountSummary from './components/AccountSummary'
import Vehicles from './components/Vehicles'
import ConfirmationModal from 'components/ConfirmationModal'
import NotificationModal from './components/NotificationModal'
import RetractablePanel from 'components/RetractablePanel'

import { statusChanged } from 'components/RequestStatus/actions'

import { CLIENT_DETAIL_URL } from 'constants'
import { CLIENT_WEEKLY_REPORT_URL } from 'constants'
import { CLIENT_WEEKLY_REPORT_LOG_URL } from 'constants'
import { CLIENT_NOTIFICATIONS_URL } from 'constants'
import { updateUserData, updateClientData } from './actions'

import './styles.scss'
import './components/SentReports/styles.scss'
import './components/SentNotifications/styles.scss'
import 'react-select/dist/react-select.css'

const images = {
  DEFAULT_USER_PICTURE: require('img/users/notUser.gif')
}

export class ClientDetail extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      client: {
        phone_number: '',
        rfc: '',
        gender: '',
        birthdate: '',
        zip_code: '',
        city: '',
        client_type: ''
      },
      user: {
        uuid: '',
        email: '',
        first_name: '',
        last_name: '',
        is_active: false,
        is_staff: false,
        picture: ''
        },
      request: {
        status: '',
        message: ''
        },
      total_vehicles: 0,
      sent_reports: [],
      notifications_list: []
      }

      this._bind(
        '_showAddVehicleModal',
        '_fetchClientDetail',
        '_sendWeeklySummary',
        '_showConfirmSendReport',
        '_showNotificationModal',
        '_showReportSent',
        '_createList',
        '_createNotificationsList',
        '_formatPhone'
      )
    }

  _showAddVehicleModal(e) {
    e.preventDefault()

    this.context.toggleModal(true, <AddVehicleModal match={this.props.match} />)
  }

  _fetchClientDetail() {
    request(CLIENT_DETAIL_URL(this.props.match.params.id))
    .then((res) => {
      this.props.updateClientData(res.client)
      this.props.updateUserData(res.user)
    })
    .catch((err) => {console.log(err)})
  }

  _fetchWeeklyReportLog() {
    request(CLIENT_WEEKLY_REPORT_LOG_URL(this.props.match.params.id))
    .then((res) => {
      this.setState({sent_reports: res.log})
    })
    .catch((err) => {console.log(err)})
  }

  _fetchNotifications() {
    request(CLIENT_NOTIFICATIONS_URL(this.props.match.params.id))
    .then((res) => {
      this.setState({notifications_list: res.notifications})
    })
    .catch((err) => {console.log(err)})
  }


  _showConfirmSendReport(e){
    e.preventDefault()
    
    this.context.toggleModal(true, <ConfirmationModal 
      _onAccept={this._sendWeeklySummary.bind(this)} 
      acceptLabel="Enviar" 
      match={this.props.match} 
      />)
  }

  _showNotificationModal(e){
    e.preventDefault()
    this.context.toggleModal(true, <NotificationModal
        _onAccept={this._sentNotificationSuccess.bind(this)} 
        match={this.props.match} 
        />)
  }

  _sentNotificationSuccess(title, content, e){
    this.props.updateRequestStatus('progress', 'Creando Notificación')
    request(CLIENT_NOTIFICATIONS_URL(this.props.match.params.id), {
      method: 'POST',
      body: {
        title: title,
        content: content
      }
    }).then((res) => {
      if (res.status === "ok" ) {
        this.setState({ request: { status: res.status, message: res.message}})
        this.props.updateRequestStatus(res.status, res.message)
        this.setState({notifications_list: [res.notification, ...this.state.notifications_list]})
      }
    }).catch((err) => {
      if (err) {
        this.props.updateRequestStatus('error', 'No pudimos crear la notificación')
      }
    })
  }

  _sendWeeklySummary(e){
    this.setState({ request: { status: 'progress', message: 'Procesando...'}})
    this.props.updateRequestStatus('progress', 'Procesando ...')
    request(CLIENT_WEEKLY_REPORT_URL(this.props.match.params.id))
    .then((res) => {
      this._showReportSent()
      this._fetchWeeklyReportLog()
    })
    .catch((err) => {console.log(err)
      this.props.updateRequestStatus('error', 'Ocurrio un error.')
    })
  }

  _showReportSent(e){
    this.setState({ request: { status: 'ok', message: 'Reporte enviado.'}})
    this.props.updateRequestStatus('ok', 'Reporte enviado.')
  }

  componentDidMount() {
    this._fetchClientDetail()
    this._fetchWeeklyReportLog()
    this._fetchNotifications()
  }

  _createList() {
    var list = []
    var sent_reports_count = this.state.sent_reports.length
    if (sent_reports_count > 0) {
      for (var i=0; i < sent_reports_count; i++ ) {
        list.push(<li key={i.toString()}>{this.state.sent_reports[i].description}</li>)
      }
    }else{
      list.push(<li key="0">Aún no se han enviado reportes</li>)
    }
    return list
  }

  _createNotificationsList() {
    var list = []
    var sent_notifications_count = this.state.notifications_list.length
    if (sent_notifications_count > 0) {
      for (var i=0; i < sent_notifications_count; i++ ) {
        const date = moment(this.state.notifications_list[i].created)
        const dateElement = date.format('DD [de] MMM YYYY')
        list.push(<li key={i.toString()}>{dateElement} - {this.state.notifications_list[i].content}</li>)
      }
    }else{
      list.push(<li key="0">Aún no se han enviado notificaciones</li>)
    }
    return list
  }

  _renderFleetSummary(){
    return (this.props.client.client_type === 'Flotilla') ? (
      <AccountSummary match={this.props.match}/>
    ) : null
  }

  _formatPhone(n){
    return (n) ? n : '-'
  }

  render() {
    const client = this.props.client
    const user = this.props.user
    const isVerifyMessage = user.is_active ? 'Usuario Activo' : 'Usuario inactivo'

    const breadcrumbKeys = {
      displayValues: { client_name: `${user.first_name} ${user.last_name}`},
      pathValues: { id: user.uuid }
    }

    const backgroundImage = !!user.picture ? user.picture : images.DEFAULT_USER_PICTURE
    const imageStyle = {
      backgroundImage: `url(${backgroundImage})`
    }
    return (
      <div id="ClientDetail">
        <Breadcrumb levels={this.props.breadcrumb} keys={breadcrumbKeys} />
        <div className="ClientDetail__user-header">
          <div className="ClientDetail__bg-mask d-flex justify-content-between">
            <div className="ClientDetail__user-data d-flex justify-content-around align-items-center">
              <div className="ClientDetail__user-picture" style={imageStyle}>
                <div className=""></div>
                <button type="button"
                        className={`status status-${user.is_active} pop-hover`}
                        data-container="body"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-title={isVerifyMessage}></button>
              </div>
              <div className="ClientDetail__user-personal">
                <h1>{`${user.first_name} ${user.last_name}`}</h1>
                <p className="email">{user.email}</p>
                <p className="email">{ this._formatPhone(client.phone_number) }</p>
                <div className="city d-flex align-items-center">
                  <i className="material-icons">location_city</i>
                  <p>{client.city}</p>
                </div>
              </div>
            </div>
            <div className="ClientDetail__user-controls d-flex align-items-center">
              <DropDown user={user} client={client}/>
            </div>
          </div>
        </div>
        <div className="row sidebar">
          <div className="col-md-4">
            <Button size="sm" onClick={this._showAddVehicleModal}>
              <i className="material-icons">add</i>
              Agregar nuevo coche
            </Button>
            { this._renderFleetSummary() }
            <EditAdditionalInfo />
            <Button size="sm" onClick={this._showConfirmSendReport}>
              <i className="material-icons">assessment</i>
              Enviar reporte semanal
            </Button>
            <RetractablePanel
              ref={(panel) => this.panel = panel}
              name="Ultimos reportes enviados"
              isToggle={true}
            >
              <ul className="SentReportsList">
                {this._createList()}
              </ul>
            </RetractablePanel>
            <br></br>
            <Button size="sm" onClick={this._showNotificationModal}>
              <i className="material-icons">add</i>
              Enviar notificación
            </Button>
            <RetractablePanel
              ref={(panel) => this.panel = panel}
              name="Últimas notificaciones enviadas"
              isToggle={true}
            >
              <ul className="SentNotificationsList">
                {this._createNotificationsList()}
              </ul>
            </RetractablePanel>
            <br></br>
          </div>
          <div className="list col-md-8">
            <Vehicles match={this.props.match}/>
          </div>
        </div>
      </div>
    )
  }
}

ClientDetail.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    client: state.clientDetail.get('client').toJS(),
    user: state.clientDetail.get('user').toJS()
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserData: (user) => dispatch(updateUserData(user)),
    updateClientData: (client) => dispatch(updateClientData(client)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetail)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/index.js